import SectionTitle from "../ui/section-title";
import { useRef } from 'react';

import { AvatarSelector } from "./AvatarSelector";

export default function AvatarBuilderSection({promo, user, userCredits}) {
  const targetRef = useRef(null);

  return (
    <section ref={targetRef} id="services" className="py-24 bg-gradient-to-br from-white to-purple-50">
      <div className="container mx-auto px-4">
        <SectionTitle 
          title="AI Avatar Builder" 
          subtitle="Create a funny video in just 30 seconds."
        />

        {promo && (
          <div className="text-left mb-8 bg-purple-100 rounded-lg text-sm px-6 py-4">
            <p className="text-lg text-gray-900 font-semibold mb-2">How to create your vide in 3 simple steps:</p>
            <p className="text-lg text-gray-900">1. Select your favourite Avatar from the list below.</p>
            <p className="text-lg text-gray-900">2. Enter the message/script you’d like the avatar to speak. </p>
            <p className="text-lg text-gray-900">3. Generate video.</p>
          </div>
        )}

        <AvatarSelector 
          targetRef={targetRef} 
          promo={promo} 
          user={user} 
          userCredits={userCredits}
        />
        
      </div>
    </section>
  );
}
